/**
 * The payer flag (slice 9b, spec 20261013 section 11.3): who last changed a
 * deal's payout details, and how long ago, in the words the Payments page
 * shows. Prism stamps every replacement; a booking is the first capture, so
 * only a later change is worth a payer's second look.
 */

//: A change older than this is history, not a warning.
const FLAG_WINDOW_MS = 30 * 24 * 3600 * 1000;

const WHO = Object.freeze({
  account: 'the customer',
  payout_portal: 'the customer',
  operator: 'staff',
})

const RELATIVE = new Intl.RelativeTimeFormat('en-GB', { numeric: 'always' })

/** "3 hours ago", "2 days ago", "5 minutes ago". */
function ago(ms) {
  const minutes = Math.max(1, Math.floor(ms / 60000))
  if (minutes < 60) return RELATIVE.format(-minutes, 'minute')
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return RELATIVE.format(-hours, 'hour')
  return RELATIVE.format(-Math.floor(hours / 24), 'day')
}

/**
 * "Details changed by the customer 3 hours ago", "Details changed by staff
 * 2 days ago", or null: a booking, no change, an unreadable stamp, or one
 * over 30 days old.
 */
export function changedNote(deal, now = new Date()) {
  const who = WHO[deal?.payoutChangedBy]
  if (!who) return null
  const changed = Date.parse(deal.payoutChangedAt ?? '')
  if (Number.isNaN(changed)) return null
  const elapsed = Math.max(0, new Date(now).getTime() - changed)
  if (elapsed > FLAG_WINDOW_MS) return null
  return `Details changed by ${who} ${ago(elapsed)}`
}

//: What the payer checks when the details changed: the bank's payee name check.
export const PAYEE_CHECK = 'Check the name your bank shows when you add the payee.'

//: The clipboard prefix for a flagged row, so a paste carries the warning too.
export const CLIPBOARD_PREFIX = 'CHANGED RECENTLY: '
